import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

const STORAGE_KEY = "demax_cookie_consent";

export function getCookieConsentAccepted() {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(STORAGE_KEY) === "accepted";
  } catch {
    return false;
  }
}

export function setCookieConsentAccepted() {
  try {
    localStorage.setItem(STORAGE_KEY, "accepted");
  } catch {
    /* ignore */
  }
}

/**
 * Minimal bottom banner — analytics in App only runs after acceptance.
 */
export default function CookieConsentBanner({ visible, onAccept, onOpenCookiePolicy }) {
  const { t } = useLanguage();

  if (!visible) return null;

  return (
    <div
      className="pointer-events-none fixed bottom-0 left-0 right-0 z-[100] px-4 pb-[max(1rem,env(safe-area-inset-bottom))] pl-[max(1rem,env(safe-area-inset-left))] pr-[max(1rem,env(safe-area-inset-right))] pt-2"
      role="dialog"
      aria-label={t("cookieBannerAria")}
    >
      <div className="pointer-events-auto mx-auto flex max-w-3xl flex-col gap-4 rounded-2xl border border-gray-200/90 bg-white/95 px-4 py-4 shadow-lg shadow-gray-900/10 backdrop-blur-md sm:flex-row sm:items-center sm:justify-between md:px-6 md:py-5">
        <p className="text-sm text-gray-600 font-sans leading-relaxed">
          {t("cookieBannerBefore")}{" "}
          {typeof onOpenCookiePolicy === "function" ? (
            <button
              type="button"
              onClick={onOpenCookiePolicy}
              className="text-[#dc2626] font-semibold hover:underline"
            >
              {t("cookieBannerLink")}
            </button>
          ) : (
            <span className="text-gray-900 font-medium">{t("cookieBannerLink")}</span>
          )}{" "}
          {t("cookieBannerAfter")}
        </p>
        <button
          type="button"
          onClick={onAccept}
          className="min-h-[48px] shrink-0 rounded-xl bg-[#0f172a] px-5 py-3 font-sans text-sm font-semibold text-white transition-colors hover:bg-[#1e293b]"
        >
          {t("cookieAccept")}
        </button>
      </div>
    </div>
  );
}
